<template>
  <div class="register" :style="{padding:paddingNum}">
    <div class="registerBox" >
      <div class="registerFrame">

        <div class="registerTitle">
            <span class="title">創建註冊新帳戶</span>
            <span>帶 </span>
            <span class="star">* </span>
            <span>號為必填項</span>
          </div>


        <div class="displayR bottomBox">
          <!--左边-->
          <div class="leftBox">

            <div class="name">
              <span>稱謂</span>
              <span class="star"> *</span>
            </div>

            <div @change="chooseGender(radio)" class="gender" style="display: flex;flex-direction: row;">
              <el-radio v-model="radio" label="1" >先生</el-radio>
              <el-radio v-model="radio" label="2">女士</el-radio>
            </div>

            <div class="fullName">
              <div class="leftName">
                <div class="name">
                  <span>姓</span>
                  <span class="star"> *</span>
                </div>
                <div class="secondName">
                  <span>名</span>
                  <span class="star"> *</span>
                </div>
              </div>

              <div class="rightBox displayR">
                <el-input v-model="input" placeholder="請輸入您的姓氏"></el-input>
                <el-input v-model="value" placeholder="請輸入您的名字"></el-input>
              </div>
            </div>

            <div class="fullName">
              <div class="leftName">
                <div class="name">
                  <span>手機號碼</span>
                  <span class="star"> *</span>
                </div>
                <div class="secondName">
                  <span>電子郵箱</span>
                  <span class="star"> *</span>
                </div>
              </div>

              <div class="rightBox">
                <el-input v-model="phoneN" placeholder="請輸入手機號碼"></el-input>
                <el-input v-model="mail" placeholder="請輸入電子郵箱"></el-input>
              </div>
            </div>

            <div class="fullName">
              <div class="leftName">
                <div class="name">
                  <span>驗證碼</span>
                  <span class="star"> *</span>
                </div>
              </div>

              <div class="rightBox">
                <el-input style="width: 140px;" v-model="codeN" placeholder="請輸入驗證碼"></el-input>
                <img class="codeImg" :src="img" alt="">
                <span class="changeImg" @click="getImg()">看不清？</span>
              </div>
            </div>

            <div class="fullName">
              <div class="leftName">
                <div class="name">
                  <span>密碼</span>
                  <span class="star"> *</span>
                </div>
                <div class="secondName">
                  <span>確認密碼 </span>
                  <span class="star"> *</span>
                </div>
              </div>

              <div class="rightBox">
                <el-input v-model="password" placeholder="請輸入密碼"></el-input>
                <el-input v-model="passwordAgin" placeholder="請再次輸入密碼"></el-input>
              </div>
            </div>

          </div>
          <div class="line"></div>

          <!--右边-->
          <div class="rightProfile">
            <div class="name" style="margin-bottom: 10px;">
              <span>配送地址</span>
            </div>
            <div @change="selectArea">
              <area-select :level="2" v-model="selected" :data="pcaa"></area-select>
            </div>
            <div>
              <el-input v-model="fullArea" placeholder="請輸入詳細地址"></el-input>
            </div>
            <div class="terms">
              <img @click="agreenTerm" ref="term" :src="agree? require('@/assets/homeImg/选中 (2).png') :require('@/assets/homeImg/没选中.png')" alt="">
              <div class="linkTerms">
                我已閱讀並接受
                <a href="">個人信息收集聲明</a>
                及
                <a href="">網站使用和銷售條款</a>
              </div>
            </div>

            <div class="createAccount" @click="createAccount"><router-link to="/profile">創建帳戶</router-link></div>

          </div>



        </div>

      </div>
    </div>

   <!--<div v-for="(item,index) in list" :key="index" v-html="item"></div>-->
  </div>
</template>

<script>
  import { provinceAndCityData, regionData, provinceAndCityDataPlus, regionDataPlus, CodeToText, TextToCode } from 'element-china-area-data'
  import { AreaCascader } from "vue-area-linkage"
  import { pca, pcaa } from 'area-data';
    export default {
      name: "Register",
      data() {
        return{
          itemW:0,
          paddingNum:'',
          mr:'',
          radio: '1',
          input: '',
          value: '',
          phoneN: '',
          fullArea: '',
          codeN: '',
          password: '',
          passwordAgin: '',
          mail: '',
          pca: pca,
          pcaa: pcaa,
          options: regionDataPlus,
          selectedOptions: [],
          selected: [],
          gender:'man',
          agree: false,
          img: '',
          key: '',
          list: ['<li>abc</li>','<li>hhhh</li>','<li>mebc</li>','<li>dddd</li>']

        }
      },
      methods:{
        choseProvince() {

        },
        selectArea () {
          console.log(this.selected);
        },
        chooseGender(gender) {
          if(gender === '1') {
            this.gender = 'man';
          }else {
            this.gender = 'female';
          }


        },
        createAccount(){
          let pattern = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
          console.log(this.gender);
          console.log(this.input);
          console.log(pattern.test(this.mail));
          let aa = document.getElementsByClassName('area-selected-trigger')
          console.log(aa[0].innerHTML+aa[1].innerHTML+aa[2].innerHTML);
          console.log(this.fullArea);

        },
        agreenTerm (){
          this.agree = !this.agree
          // console.log();
        },
        //获取图片验证
        getImg(){

          this.$axios.get('api/app_v1/captcha',{
          }).then(res=>{
            console.log(res.data.data);
            this.img = res.data.data.url.img;
            this.key = res.data.data.url.key;
            // img: '',
            //   key: '',
            // this.img = res.data.data.url.img;
            // this.key = res.data.data.url.key;
          }).catch(error=>{
            if (error.response) {
              // 请求已发出，但服务器响应的状态码不在 2xx 范围内
              Toast(error.response.data.error.message)
            } else {
              // Something happened in setting up the request that triggered an Error
              console.log('Error', error.message);
            }
            console.log(error);
          })
        },
        /*last_name:'',first:'',area_code:'86',gender:'f',mobile:'',
        facebook_mail:'',district_id:'3',address:''
        * */
        //注册mall_api/create_customer
        //注册发送验证码mall_api/sms/send_sms_verification_code
        getCode(){
          this.$axios.get('mall_api/sms/send_sms_verification_code',{
            mobile:'',
            sentType:'r',
            area_code: ''
          }).then(res=>{
            // this.productType = res.data.data;
            console.log(res.data.data);
            this.productSeries = res.data.data
          }).catch(error=>{
            if (error.response) {
              // 请求已发出，但服务器响应的状态码不在 2xx 范围内
              console.log(error.response.data.error.message);
              // console.log(error.response.status);
              // console.log(error.response.headers);
            } else {
              // Something happened in setting up the request that triggered an Error
              console.log('Error', error.message);
            }
          });
        },
        sendCode(){
          let that = this;
          if(this.phoneN && this.number){
            if(this.couponSelected===86){
              if(!(/^1[3456789]\d{9}$/.test(that.value))){
                Toast("手机号码有误，请重填");
                return false;
              }else {
                //获取验证码接口
                this.getCode()
              }

            }else {
              if(!(/^(5|6|8|9)\d{7}$/.test(that.value))){
                Toast("手机号码有误，请重填");
                return false;
              }else {
                this.getCode()

              }
            }

          }
        },
      },


      mounted(){
        //获取图片验证码
        // this.getImg()
      },
      created() {

        let aa = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth

        // console.log(this.itemW );
        if(aa>=1900) {
          this.paddingNum = '0 210px';
          this.mr = '210px';
          this.itemW = (aa - 210)/4-10*2
        }else {
          this.paddingNum = '0 100px';
            this.mr = '100px';
          this.itemW = (aa - 100)/4-10*2
        }


      }
    }
</script>

<style scoped>
  .registerBox {
    width: 100%;
    padding: 0 100px;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;

  }

  .registerFrame {
    width: 100%;
    height: 606px;
    background-color: #F7F5F1;
    padding: 15px;
    color: #979694;
    font-size: 14px;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;

  }
  .registerTitle {
    padding-top: 10px;
    padding-bottom: 10px;
  }
  .title {
    color: #1E1303;
    font-size: 20px;
  }
  .bottomBox {
    width: 100%;
    height: 91%;
    /*height: 100%;*/
    background-color: #fff;
    padding-left: 50px;
    padding-right: 50px;
    /*padding: 20px 50px 0 50px;*/
    justify-content: center;
    align-items: center;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
  }
  .star {
    color: #BF4444;
  }
  .name {
    padding-bottom: 10px;
  }
  .leftName {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
  .leftName>div {
    flex: 1;
  }
  .leftBox,.rightBox {
    flex: 1;
  }
  .line {
    width: 1px;
    height: 260px;
    background-color: #ddd;
    margin: 0 50px;
  }
  .rightBox {
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  .leftName {
    margin-top: 10px;
  }
  .rightBox .el-input:first-child {
    margin-right: 40px;

  }

  .name {
    margin-right: 45px;
  }
  .codeImg {
    width: 105px;
    height: 40px;
    background-color: #f00;
  }
  .changeImg {
    width: 60px;
    margin-left: 10px;
    text-align: center;
    border-bottom: 1px solid #979694;
    font-size: 12px;
  }
  .rightProfile {

  }
  .terms {
    margin-top: 10px;
    margin-bottom: 60px;
    display: flex;
    flex-direction: row;
  }
  .terms>img {
    width: 18px;
    height: 19px;
  }
  .createAccount {
    width: 226px;
    height: 40px;
    background-color: #1E1303;
    color: #fff;
    -webkit-border-radius: 4px;
    -moz-border-radius: 4px;
    border-radius: 4px;
    line-height: 40px;
    text-align: center;
    margin: 0 auto;
  }
  .createAccount>a {
    display: block;
    color: #fff;
    width: 100%;
    height: 100%;
  }
  .linkTerms>a {
    color: #7A7977;
    text-decoration: underline;
  }
</style>



// WEBPACK FOOTER //
// src/views/viewHK/Register.vue